import { read } from '../common/utils';
import eventNames from '../common/event-names';

function stopListening(intervalId) {
  window.clearInterval(intervalId);
}

export function startListening(handleData) {
  try {
    const intervalId = window.setInterval(() => {
      const data = read(eventNames.LOGIN_EVENT);
      if (data) {
        handleData(data);
        stopListening(intervalId);
      }
    }, 500);
    return () => stopListening(intervalId);
  } catch (e) {
    console.error(e);
  }
}
